import React from "react";
import { Leaf, ShieldCheck, Wallet } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function WhyJoinFreshMart() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const benefits = [{
    title: "Clinical Excellence",
    description: "My approach is built on decades of professional medical experience and deep clinical understanding of patient needs.",
    icon: Leaf
  }, {
    title: "Research-Backed Strategy",
    description: "Every guidance path I develop is rooted in the latest diagnostic protocols and evidence-based medical research.",
    icon: Wallet
  }, {
    title: "Patient Advocacy",
    description: "I serve as your dedicated voice within the healthcare system, ensuring your choices and dignity are always protected.",
    icon: ShieldCheck
  }];
  return <section data-section-id="22110" id="what-makes-this-different" className="bg-background py-12 md:py-24">
      <div className="container mx-auto px-4">
        <div ref={ref} className={cn("mx-auto max-w-lg transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <div className="mb-10 text-center md:text-left">
            <h2 className="text-4xl font-serif tracking-tight text-foreground sm:text-5xl">
              What Makes This Different
            </h2>
            <p className="mt-4 text-lg font-sans text-muted-foreground">
              A specialized approach to medical navigation that combines clinical rigor with unwavering compassionate support.
            </p>
          </div>

          <div className="flex flex-col gap-8">
            {benefits.map((item, i) => <div key={i} data-index={i} className="flex items-start gap-5 group">
                <Badge variant="secondary" className="mt-1 flex size-12 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary hover:bg-primary/20 transition-colors border-0">
                  <item.icon className="size-6" />
                </Badge>
                <div className="space-y-1">
                  <h3 className="text-2xl font-bold font-sans text-foreground group-hover:text-primary transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-lg font-sans text-muted-foreground leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}